export type VehicleFilterType = {
  key?: string;
  role?: string;
  userId?: string;
  requestInspection?: boolean;
};

export type VehiculeCheckFilterType = {
  vehiculeId?: string;
  actionUserId?: string;
  status?: string;
  type?: string;
  startDate?: string;
  endDate?: string;
  groupId?: string;
  companyId?: string;
  branchId?: string;
} & VehicleFilterType;

export enum VehicleLocalStorage {
  KEY = 'vehicleFilterKey',
  STATUS = 'vehicleFilterStatus',
  START_DATE = 'vehicleFilterStartDate',
  END_DATE = 'vehicleFilterEndDate',
  REQUEST_INSPECTION = 'vehicleFilterRequestInspection',
  GROUP_ID = 'vehicleFilterGroupId',
  COMPANY_ID = 'vehicleFilterCompanyId',
}
